import React, { Component } from "react";
import GuestHeader from "./GuestHeader/GuestHeader";
import GuestContent from "./GuestContent/GuestContent";
import { Container } from "react-bootstrap";
require("./GuestHomePage.scss");

class GuestHomePage extends Component {
  render() {
    return (
      <Container className="guest-page-container">
        <GuestHeader />
        <GuestContent />
      </Container>
    );
  }
}

export default GuestHomePage;
